import { useTranslation } from 'react-i18next'
import type { ResourceGroup } from '../data/oleshkyResources'
import EmbeddedVideo from './VideoPlayer/EmbeddedVideo'

// Key resources section, styled like Resources.tsx, built from a list of link groups.
export function ResourceList({ groups }: { groups: ResourceGroup[] }) {
  const { t } = useTranslation()

  return (
    <section className='flex flex-col gap-10 px-6 md:px-20 py-25 bg-gray-100 text-center text-xl md:text-2xl leading-relaxed opacity-90 items-center'>
      <h3 className='text-4xl md:text-5xl font-medium'>{t('resources.title')}</h3>
      {groups.map(({ title, links, i18n, video }, i) => (
        <div key={i} className='space-y-3 max-w-4xl w-full mx-auto'>
          <strong className='block text-2xl'>{i18n ? t(title) : title}</strong>
          {video && <EmbeddedVideo video={video} title={i18n ? t(title) : title} />}
          {links.map(({ label, href, date }) => (
            <a
              key={href}
              href={href}
              target='_blank'
              rel='noopener noreferrer'
              className='underline text-blue-600 block'
            >
              {i18n ? t(label) : label}
              {date && ` (${date})`}
            </a>
          ))}
        </div>
      ))}
    </section>
  )
}
